import { GeocodeResponse, ShippingAddressGeocode } from '../types/hereMaps'

export enum GeocodeValidation {
  NoMatch,
  Ambiguous,
  Valid,
}

export function validateGeocodeResult(
  geocodeResponse: GeocodeResponse,
): GeocodeValidation {
  if (
    geocodeResponse.items.length === 0 ||
    geocodeResponse.items.every((item) => item.resultType !== 'houseNumber')
  ) {
    return GeocodeValidation.NoMatch
  } else if (
    geocodeResponse.items.length > 1 &&
    geocodeResponse.items.every((item) => item.resultType === 'houseNumber') &&
    geocodeResponse.items.every((item) => item.scoring.queryScore >= 1)
  ) {
    return GeocodeValidation.Ambiguous
  }
  return GeocodeValidation.Valid
}

export function isAddressGeocode(
  input: unknown,
): input is ShippingAddressGeocode {
  return (
    input != null &&
    typeof input === 'object' &&
    'addressLine' in input &&
    'postalCode' in input &&
    'city' in input &&
    'state' in input &&
    'country' in input
  )
}
